export default __webpack_public_path__ + "static/media/Grisens-udvikling.2e81a23d.jpg";